import React from 'react';
import { connect } from "react-redux";
import * as fileCrud from '../../../../../crud/file.crud';
import axios from 'axios';
import * as forecastBatchCrud from '../../../../../crud/forecastBatch.crud';
import * as forecastCrud from '../../../../../crud/forecast.crud';
import * as projectOrderCrud from '../../../../../crud/projectOrder.crud';
import BaseDocument from '../../../_CustomComponents/BaseDocument';
import { withSnackbar } from 'notistack';
import { confirm } from 'devextreme/ui/dialog';
import { Portlet, PortletBody } from "../../../../../partials/content/Portlet";
import BiDynamicForm from '../../../../../partials/layout/BiDynamicForm';
import moment from 'moment';
import PortletSpinner from '../../../../../partials/layout/PortletSpinner';
import { ValidationGroup } from 'devextreme-react';
import { injectIntl } from "react-intl";
import Common from '../../../../../shared/common';
import { actionCodes } from "../../../../../shared/lookup";

const rightAlignedNumberBox = {
  editorOptions: {
    elementAttr: { class: 'text-right' }
  }
};

const initialState = {
    batchDrafts: null,
    projectOrders: null,
    fileUploading: false,
    files: null
}

class SecondWizardPage extends BaseDocument {
    constructor(props) {
        super(props);

        this.validatorRef = React.createRef();

        this.batchForecastForPackagedContractEnabled = props.workflowsQA['72'] && props.contract.ispackaged;

        if (this.batchForecastForPackagedContractEnabled) {
            this.projectOrderNotificationName = this.props.workflowsQA['72'].notificationName;
        }

        this.communicateButtonEnabled = props.workflowItem.userFilters?.mainNotice?.communicateAllowed;

        this.state = { ...initialState };
    }

    componentDidMount() {
        this.getDrafts();
    }

    componentDidUpdate(prevprops, prevSatate) {
        if (this.props.forecastBatchId !== prevprops.forecastBatchId) {
            this.setState({ ...initialState }, () => {
                this.getDrafts();
            });
        }
    }

    getDrafts = async () => {
        try {
            await this.props.closeSnackbar("PersistentFormWarning");
            const { data: batchDrafts } = await forecastBatchCrud.batchGetDrafts(this.props.forecastBatchId);

            const projectOrderIds = batchDrafts.flatMap(item => item.projectorders || []);

            const { contractid } = this.props.contract;
            const { data: responseObj } = await projectOrderCrud.getProjectOrdersToSelectList(contractid);

            const idsToFilter = Array.isArray(projectOrderIds) ? projectOrderIds : [];

            const filteredResponse = responseObj.filter(TO => 
                // Check if the current project order's ID is included in the input array
                idsToFilter.includes(TO.projectorderid)
            );

            const projectOrders = filteredResponse.map(PO => ({
                value: PO.projectorderid,
                reference: PO.referenceid,
                display: `${PO.referenceid} - ${PO.subject}`,
                completed: PO.pmcompletiondate !== null
            }));

            const lastForecastReferences = await this.fetchLastForecastAmountsForProjectOrders(projectOrderIds);

            const mappedBatchDrafts = this.mapBatchDrafts(batchDrafts, projectOrders);

            let hasAnyRecalculated = false;

            const validatedDrafts = mappedBatchDrafts.map((draft, index) => {
                const reference = lastForecastReferences[index];
                const expectedAmount = reference?.amount;

                console.log('Expected Amount:', expectedAmount);

                const newCostForecastName = `newcostforecast${index + 1}`;

                const currentDraftNewCostForecastAmount = draft[newCostForecastName];

                console.log('Current Amount:', currentDraftNewCostForecastAmount);

                if (
                    expectedAmount != null &&
                    currentDraftNewCostForecastAmount !== expectedAmount &&
                    reference?.ispmcertifiedcomplete
                ) {
                    hasAnyRecalculated = true;

                    // Update the draft object directly
                    draft[newCostForecastName] = expectedAmount;
                }

                return draft;
            });

            // 3. Show Snackbar once if any item in the batch was updated
            if (hasAnyRecalculated) {
                this.props.enqueueSnackbar(
                    this.props.intl.formatMessage({ id: 'CONTRACT.WF.FORECAST.WARNING.RECALCULATED' }),
                    { variant: "warning", key: "PersistentFormWarning", persist: true }
                );
            }

            let finalBatchDrafts = [];

            for (const draft of validatedDrafts) {
                let files = [];
                if (draft.forecastids && draft.forecastids.length > 0) {
                    // AWAIT ensures only one fetchFiles call is active at a time
                    files = await this.fetchFiles(draft.forecastids[0]);
                }
                finalBatchDrafts.push({ ...draft, files: files || [] });
            }

            this.setState({ batchDrafts: finalBatchDrafts, projectOrders });
        } catch (err) {
            if (!axios.isCancel(err)) {
                this.props.enqueueSnackbar(err.toString(), { variant: "error" });
            }
        }
    };

    fetchLastForecastAmountsForProjectOrders = async (projectOrderIds) => {
        try {
            const contractId = this.props.contract.contractid;

            const { data } = await forecastCrud.getLastForecastAmounts(
                contractId,
                projectOrderIds
            );

            const lastForecastAmounts = data || [];

            this.setState({ lastForecastAmounts });

            return lastForecastAmounts;
        } catch (err) {
            console.log(err);
        }
    };

    fetchFiles = async (forecastid) => {
        try {
            const { companyid, projectid, contractid } = this.props.contract;
            const { data } = await fileCrud.getContractNotificationFiles(companyid, projectid, contractid, forecastid, this.props.workflowItem.config.documentType);
            const filesList = JSON.parse(data.aggregatelist);
            //this.setState({ files: filesList });
            return filesList;
        } catch (err) {
            if (!axios.isCancel(err)) {
                this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
            }
        }
    }

    mapBatchDrafts = (batchDrafts, projectOrders) => {
        return batchDrafts.map((item, index) => {
            const newItem = { ...item };

            const i = index + 1;

            if (Array.isArray(item.newcostforecasts) && item.newcostforecasts.length > 0) {
                newItem[`newcostforecast${i}`] = item.newcostforecasts[0];
            }
            // if (Array.isArray(item.targets) && item.targets.length > 0) {
            //     newItem[`target${i}`] = item.targets[0];
            // }
            // if (Array.isArray(item.actuals) && item.actuals.length > 0) {
            //     newItem[`actual${i}`] = item.actuals[0];
            // }
            // if (Array.isArray(item.variances) && item.variances.length > 0) {
            //     newItem[`variance${i}`] = item.variances[0];
            // }
            // if (Array.isArray(item.currencies) && item.currencies.length > 0) {
            //     newItem[`currency${i}`] = item.currencies[0];
            // }
            if (Array.isArray(item.projectorders) && item.projectorders.length > 0) {
                newItem[`projectorderid${i}`] = item.projectorders[0];
                newItem[`projectorderreference${i}`] = projectOrders.find(x => x.value === item.projectorders[0]).reference;
            }

            delete newItem.newcostforecasts;
            // delete newItem.targets;
            // delete newItem.actuals;
            // delete newItem.variances;
            // // delete newItem.currencies;

            return newItem;
        });
    }

    onValueChanged = async (field, value) => {
        this.props.onValueChanged(true, null);
        
        if (field) {
            this.state.batchDrafts[field] = value;
        }
    }

    initialButtonHandler = async (payment) => {
        const response = await this.communicateAll();

        if (!response) {
            return; //cancelled
        }

        this.submitHandler(payment, "COMMUNICATE");
    }

    secondaryButtonHandler = async () => {
        const payment = { ...this.state.batchDrafts };

        this.submitHandler(payment, "SAVE_DRAFT");
    }

    communicateAll = async () => {
        const communicatedToParty = this.props.workflowItem.notifyingParty === "PM" ? this.props.globalResources.SUPPLIER_NAME : this.props.globalResources.PM_NAME
        const warningMessage = this.props.intl.formatMessage({ id: 'CURRENCY_BATCH_MODAL.COMMUNICATE.WARNING' }, { ITEM_NAME: this.props.workflowItem.notificationName, PARTY_NAME: communicatedToParty });
        const warningMessageTitle = this.props.intl.formatMessage({ id: 'CURRENCY_BATCH_MODAL.COMMUNICATE.WARNING_TITLE' });
        let result = await confirm(`<div style="max-width:50vw;">${warningMessage}</div>`, `${warningMessageTitle}`);
        return result;
    }

    extractValuesByIndex = (items, source, keyPrefix) => {
        if (!Array.isArray(items) || !source || typeof keyPrefix !== 'string') {
            return [];
        }

        return items.map((_, index) => {
            const valueIndex = index + 1;
            const keyWithNumber = `${keyPrefix}${valueIndex}`;
            const keyWithUnderscore = `${keyPrefix}_${valueIndex}`;

            if (keyWithNumber in source) {
                return source[keyWithNumber];
            } else if (keyWithUnderscore in source) {
                return source[keyWithUnderscore];
            } else {
                return null;
            }
        });
    }

    submitHandler = async (forecast, mode) => {
        if (forecast.forecastdate) {
            forecast.forecastdatedisplay = moment(forecast.forecastdate).format('DD/MM/YYYY');
        }

        let actioncode = actionCodes.COMMUNICATE;
        let status = 'Communicated';

        if (mode == 'SAVE_DRAFT') {
            actioncode = actionCodes.SAVE_DRAFT;
            status = 'Not Communicated';
        }

        forecast.actioncode = actioncode;
        forecast.status = status;

        delete forecast.newcostforecastTotal;
        // delete forecast.targetTotal;
        // delete forecast.actualTotal;
        // delete forecast.variance_Total;

        const forecastids = this.state.batchDrafts.map(x => x.forecastids[0]);
        forecast.forecastids = forecastids;

        const newcostforecasts = this.extractValuesByIndex(forecastids, forecast, 'newcostforecast');
        forecast.newcostforecasts = newcostforecasts;

        // const targets = this.extractValuesByIndex(forecastids, forecast, 'target');
        // forecast.targets = targets;

        // const actuals = this.extractValuesByIndex(forecastids, forecast, 'actual');
        // forecast.actuals = actuals;

        // const variances = this.extractValuesByIndex(forecastids, forecast, 'variance');
        // forecast.variances = variances;

        forecast.currencies = this.state.currencies;

        forecast.subject = this.state.batchDrafts.subject;
        forecast.description = this.state.batchDrafts.description;
        forecast.replycomment = this.state.batchDrafts.replycomment;

        forecast.showtasknotification = 1;

        forecastBatchCrud.batchNotify(forecast, this.props.contract.contractid, this.props.forecastBatchId)
            .then(() => {
                this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: 'GENERAL.COMMUNICATON.SAVED_SUCCESS' }), { variant: 'success', });
                try {
                    if (mode == 'SAVE_DRAFT') {
                        this.props.onValueChanged(false, null);
                        this.getDrafts();
                    } else {
                        this.props.onClose(null, true);
                    }
                }
                catch {
                    this.props.onClose(null, true);
                }
            })
            .catch(err => {
                this.props.enqueueSnackbar(err.toString(), { variant: 'error', key: "PersistentFormWarning", persist: true });
            });
    }

    uploadFile = (data, config, forecastid) => {
        let workflowid = 52;
        
        const { companyid, projectid, contractid } = this.props.contract;
        return fileCrud.uploadContractNotificationFiles(companyid, projectid, contractid, this.props.workflowItem.config.documentType, forecastid, workflowid, undefined, data, config);
    }

    // calculateVariance = (index, obj) => {
    //     const prc1 = obj[`target${index}`] || 0;
    //     const prc2 = obj[`newcarbonforecast${index}`] || 0;
    //     return prc2 - prc1;
    // }

    formatProjectOrder = (index) => {
        const po = this.state.projectOrders[index - 1]?.display;
        return po;
    }

    duplicateFieldWithCount(field, count, calculationFunction) {
        const duplicatedFields = [];

        for (let i = 0; i < count; i++) {
            const colIndex = i + 1;

            const duplicatedField = {
                label: `${field.label} ${colIndex}`,
                dataField: `${field.dataField}${colIndex}`,
                required: field.required,
                editorType: field.editorType,
                horizontalfield: true,
                editorOptions: { ...field.editorOptions }
            };

            if (i === 0 && field.resource) {
                duplicatedField.resource = field.resource;
            }

            duplicatedField.currency = this.props.contract.currency;

            if (field.value) {
                duplicatedField.value = field.value.bind(null, colIndex);
            }

            if (this.state.lastForecastAmounts[i]?.ispmcertifiedcomplete &&
                field.editorType === 'dxNumberBox' //this check is to make sure that the value function is only assigned for the cost forecast fields, and not to override project order's value function which is to format the display of project order reference
            ) {
                duplicatedField.editorOptions.readOnly = true;
                duplicatedField.value = this.calculateLastForecastAmount.bind(this, colIndex);
            }

            duplicatedFields.push(duplicatedField);
        }

        return duplicatedFields;
    }

    calculateLastForecastAmount = (index, obj) => {
        return this.state.lastForecastAmounts[index - 1]?.ispmcertifiedcomplete ? this.state.lastForecastAmounts[index - 1]?.amount : 0;

        // const lastAmountData = this.state.lastForecastAmounts[index - 1];
    
        // if (lastAmountData?.ispmcertifiedcomplete) {
        //     return lastAmountData.amount || 0;
        // }
        
        // return obj[`newcostforecast${index}`] || 0;
    };

    calculateRowTotal = (dataFieldBase, obj) => {
        const columnCount = this.state.projectOrders.length;
            
        let total = 0;
        for (let i = 1; i <= columnCount; i++) {
            const fieldKey = `${dataFieldBase}${i}`;

            //If fieldKey is undefined, set value and break the loop
            if (fieldKey === 'undefined1') {
                total = this.props.intl.formatMessage({ id: 'PAYMENT.BATCH_WIZARD.TOTAL' });
                break; // Exit the loop
            }

            //This is used for fields where user input is requested
            if (obj[fieldKey] === undefined) {
                const batchDrafts = this.state.batchDrafts;
        
                if (!batchDrafts || batchDrafts.length === 0) {
                    return 0;
                }

                const fieldKey = `${dataFieldBase}${i}`;
                
                const draftItem = batchDrafts[i - 1];
                
                const value = draftItem[fieldKey];
                
                total += value || 0;
            }

            //The rest is taken from the object
            total += (obj[fieldKey] || 0);
        }
        
        return total;
    };

    generateFieldsWithDuplicates(fields) {
        const updatedFields = [];

        fields.forEach(field => {
            if (field.columnCount) {
                // 1. Generate the standard duplicated fields (Project Order 1, 2, etc.)
                const duplicatedFields = this.duplicateFieldWithCount(field, field.columnCount, field.value);

                // 2. Add the Total column only if batch payment for packaged contract is enabled
                if (this.batchForecastForPackagedContractEnabled) {
                    // Create the Total field definition
                    const totalField = {
                        label: this.props.intl.formatMessage({ id: 'PAYMENT.BATCH_WIZARD.TOTAL' }), 
                        dataField: `${field.dataField}Total`,
                        editorType: field.hasOwnProperty('dataField') ? 'dxNumberBox' : 'dxTextBox', //For total label, we use TextBox
                        horizontalfield: true,
                        readOnly: true,
                        value: this.calculateRowTotal.bind(this, field.dataField),
                        editorOptions: {
                             currency: this.props.contract.currency, 
                             readOnly: true,
                             elementAttr: { class: 'text-right' }
                        }
                    };
                    duplicatedFields.push(totalField);
                }

                const transformedField = {
                    horizontalrow: true,
                    ...(field.label && { label: field.label }),
                    ...(field.resource && { resource: field.resource }),
                    // The horizontalfields array now contains the base columns and, optionally, the Total column
                    horizontalfields: duplicatedFields.map(duplicatedField => ({ ...duplicatedField }))
                };
                updatedFields.push(transformedField);
            } else {
                updatedFields.push(field);
            }
        });

        return updatedFields;
    }

    render() {
        const { companyid, projectid, contractid } = this.props.contract;
        
        if ((this.props.forecastBatchId && !this.state.batchDrafts) || !this.state.projectOrders || !this.state.lastForecastAmounts) {
            return (<PortletSpinner />);
        }

        const { fields } = this.props.workflowItem;

        // const formConfig = {
        //     model: 'ForecastBatch',
        //     title: this.props.workflowItem.notificationName,
        //     submitButtonText: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.BUTTON_COMMUNICATE' }),
        //     onSubmit: this.communicateHandler,
        //     fields: []
        // };

        // if (this.batchForecastForPackagedContractEnabled) {
        //     // Show project order forecasts
        //     this.state.batchDrafts.forEach((draft, index) => {
        //         const po = this.state.projectOrders.find(p => p.value === draft.projectorderid);
        //         if (po) {
        //             formConfig.fields.push({
        //                 label: `${po.display} - Forecast Amount`,
        //                 dataField: `forecast${index + 1}`,
        //                 editorType: 'dxNumberBox',
        //                 editorOptions: {
        //                     format: '#,##0.00',
        //                     min: 0,
        //                     disabled: po.completed
        //                 },
        //                 validation: { type: 'required' },
        //                 defaultValue: draft.amount
        //             });
        //         }
        //     });
        // }

        const minAmount = 1;//!this.state.minValueAccepted && this.state.minValueDecided ? 1 : 0;

        const columnCount = this.state.projectOrders.length;

        const createFormConfig = {
            currencyCode: this.props.contract.currency,
            buttonResource: "PAYMENT.BATCH_WIZARD.BUTTON.COMMUNICATE",
            fields: [
                { label: fields.Subject.label, dataField: 'subject' },
                { label: fields.ForecastDate.label, dataField: 'forecastdate', editorType: 'dxDateBox', required: true },
                { label: fields.Details.label, dataField: 'description', editorType: 'dxHtmlEditor' }
            ]
        };

        if (fields.Type.visible) {
            createFormConfig.fields.splice(2, 0, ({ label: fields.Type.label, dataField: 'replycomment', editorType: 'dxSelectBox', editorOptions: { dataSource: fields.Type.clauses,  valueExpr: 'display', displayExpr: 'display' } }));
        }

        // Add the 'Total' label to the end of the Project Order references
        const horizontalLabels = [
            ...this.state.projectOrders.map(x => x.reference),
            this.props.intl.formatMessage({ id: 'PAYMENT.BATCH_WIZARD.TOTAL' }) //Added Total Label
        ];

        createFormConfig.fields.push(
            { horizontallabels: horizontalLabels },
            { label: this.projectOrderNotificationName, value: this.formatProjectOrder, editorType: 'dxTextArea', columnCount: columnCount, editorOptions: { autoResizeEnabled: true } },
        );

        createFormConfig.fields.push({ label: fields.CostForecast.label, dataField: 'newcostforecast', required: true, editorType: 'dxNumberBox', columnCount: columnCount, ...rightAlignedNumberBox, validation: { type: 'range', min: minAmount, warning: this.props.intl.formatMessage({ id: "GENERAL.FORMS.MINIMUM_VALUE" }) + " " + Common.FormatCurrencyNum(minAmount, this.props.contract.currency)} });

        // if (fields.Target?.visible) {
        //     createFormConfig.fields.push({ label: fields.Target.label, dataField: 'target', required: true, editorType: 'dxNumberBox', columnCount: columnCount, editorOptions: { ...rightAlignedNumberBox.editorOptions, defaultValue: this.state.target, format: '#,##0.00 ' + this.props.intl.formatMessage({ id: 'GENERAL.FORMS.LABEL_TONNES_CO2' }), placeholder: '0 ' + this.props.intl.formatMessage({ id: 'GENERAL.FORMS.LABEL_TONNES_CO2' }) } })
        // }
        // // if (fields.Forecast?.visible) {
        // //     createFormConfig.fields.push({ label: fields.Forecast.label, dataField: 'newcarbonforecast', editorType: 'dxNumberBox', editorOptions: { defaultValue: this.state.carbonForecast, min: 0, format: '#,##0.00 ' + this.props.intl.formatMessage({ id: 'GENERAL.FORMS.LABEL_TONNES_CO2' }), placeholder: '0 ' + this.props.intl.formatMessage({ id: 'GENERAL.FORMS.LABEL_TONNES_CO2' }) } })
        // // }
        // if (fields.Actual?.visible) {
        //     createFormConfig.fields.push({ label: fields.Actual.label, dataField: 'actual', required: true, editorType: 'dxNumberBox', columnCount: columnCount, editorOptions: { ...rightAlignedNumberBox.editorOptions, format: '#,##0.00 ' + this.props.intl.formatMessage({ id: 'GENERAL.FORMS.LABEL_TONNES_CO2' }), placeholder: '0 ' + this.props.intl.formatMessage({ id: 'GENERAL.FORMS.LABEL_TONNES_CO2' }) } })
        // }
        // if (fields.Variance?.visible) {
        //     createFormConfig.fields.push({ label: fields.Variance.label, dataField: 'variance_', required: true, editorType: 'dxNumberBox', value: this.calculateVariance, columnCount: columnCount, editorOptions: { ...rightAlignedNumberBox.editorOptions, defaultValue: this.state.variance, format: '#,##0.00 ' + this.props.intl.formatMessage({ id: 'GENERAL.FORMS.LABEL_TONNES_CO2' }), placeholder: '0 ' + this.props.intl.formatMessage({ id: 'GENERAL.FORMS.LABEL_TONNES_CO2' }) } })
        // }

        const updatedFields = this.generateFieldsWithDuplicates(createFormConfig.fields);

        return (
            <div style={{ marginTop: 10 }}>
                {
                    <Portlet>
                        <PortletBody style={{ maxWidth: 1001, height: 'auto' }}>
                            <ValidationGroup ref={this.validatorRef} name={this.validatorName}>
                                <BiDynamicForm
                                    {...this.props}
                                    onSubmitHandler={this.initialButtonHandler}
                                    buttonDisabled={!this.communicateButtonEnabled}
                                    item={this.state.batchDrafts}
                                    config={{ ...createFormConfig, fields: updatedFields }}
                                    customFields={(this.customFields || {}).COMMUNICATION}
                                    valueChangeHandler={this.onValueChanged}
                                    externalFileUploadItems={this.state.batchDrafts}
                                    batchPaymentForPackagedContractEnabled={this.batchForecastForPackagedContractEnabled}
                                    secondaryButtonEnabled={true}
                                    secondaryButtonActive={true}
                                    secondaryButtonDeactiveText={this.props.intl.formatMessage({ id: "PAYMENT.BATCH_WIZARD.BUTTON.EXIT_WIZARD" })}
                                    secondaryButtonHandler={this.secondaryButtonHandler}
                                    secondaryButtonDeactiveStyle={{ width: "112px" }}
                                    onUploadFile={this.uploadFile}
                                    onDeleteContractFile={(fileid) => { return fileCrud.deleteContractFile(companyid, projectid, contractid, fileid) }}
                                    onFilesCountChanged={this.props.onFilesCountChanged}
                                    onFileUploadFinish={() => this.setState({ fileUploading: false })}
                                    onFileUploadStart={() => this.setState({ fileUploading: true })}
                                />
                            </ValidationGroup>
                        </PortletBody>
                    </Portlet>
                }
            </div>
        );
    }
}

const mapStateToProps = store => ({
    contract: store.contract.contract,
});

export default injectIntl(withSnackbar(connect(mapStateToProps)(SecondWizardPage)));